
<template>
  <section v-if="designvideolist.length == 0 && activitylist.length > 0" class="event">
    <div>
      <!-- <li v-for="item in activitylist" :key="item.id">
        <EventCard :item="item" />
      </li> -->
      <Event />
    </div>
  </section>
  <section v-else class="home">
    <div  class="content-left">
      <div>
        <div class="video-box">
          <strong>{{$t('global.视频')}}</strong>
          <div @click="showVideoSortList">
            <span>
              <img :src="sortVideoSelected.icon" />
              {{sortVideoSelected.title}}
            </span>
            <ul @click.stop="sortVideo" v-if="showVideoSort">
              <li v-for="item in sortList" :key="item.id" :data-sort="item._id">
                <img :src="item.icon" />
                {{item.title}}
              </li>
            </ul>
          </div>
        </div>
        <div class="video-start" v-if="designvideolist.length > 0">
          <ul>
            <li v-for="item in designvideolist" :Key="item.videoId">
              <VideoCard :item="item" :language="language" />
            </li>
          </ul>
          <Loading v-if="videoLoading" />
          <Reload v-if="loadError" @callback="loadMore" />
          <no-more v-if="!hasNextPage && designvideolist.length" />
        </div>

        <content-empty
          style="padding-bottom:30px"
          v-else-if="designvideolist.length == 0 && !videoLoading"
          :content="$t('global.没有相关的视频')"
        ></content-empty>
      </div>
    </div>
    <div class="contentright">
      <div class="communActivity philosopher" v-if="activitylist.length != 0">
        <strong>{{$t('global.活动')}}</strong>
        <span class="showAll" @click="navTo('event')">
          {{$t('global.查看全部')}}
          <img src="/static/v2/match/view_all_tri.png" />
        </span>
      </div>
      <div class="deliberate activitylist" v-if="activitylist.length != 0">
        <ul>
          <li v-for="activity in activitylist" :key="activity.id">
            <router-link
              :to="activity.type==1?`/live/liveDetail?id=`+activity.id:`/activity/${activity.id}/detail`"
            >
              <div class="left">
                <img :src="activity.verticalThumb | imageUrl('',190,252)" alt />
                <p class="live" v-if="activity.type == 1">{{$t('global.直播')}}</p>
                <span
                  class="liveNow"
                  v-if="activity.type == 1 && activity.status == 5"
                >{{$t('live.直播中')}}</span>
                <span
                  class="unstart"
                  v-if="activity.type == 1 && activity.status == 2"
                >{{$t('live.即将开始')}}</span>
                <span
                  v-if="activity.type == 2"
                  :class="{unstart:activity.status===2,liveNow:activity.status===5}"
                >{{activityStatusText[activity.status]}}</span>
              </div>
              <div class="right">
                <h4>{{activity.title}}</h4>
                <span v-if="activity.type == 1">{{formatDate(activity.holdStartTime)}}</span>
                <span
                  v-if="activity.type == 2"
                >{{activity.holdStartTime|formatDate('YYYY.MM.DD') }} - {{activity.holdEndTime|formatDate('YYYY.MM.DD')}}</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="communActivity philosopher" v-if="philosopherman.length > 0">
        <strong>{{$t('global.创作者')}}</strong>
        <span class="showAll" @click="navTo('creator')">
          {{$t('global.查看全部')}}
          <img src="/static/v2/match/view_all_tri.png" />
        </span>
      </div>
      <div class="philosoman" v-if="philosopherman.length > 0">
        <ul>
          <li v-for="item in philosopherman" :key="item.nickName">
            <router-link
              target="_blank"
              :class="{'userType2':item.userType === 2 && item.isCertification === 1}"
              :to="'/peopleCenter/'+item.userId"
            >
              <div class="avatarLine">
                <img :src="item.avatar | imageUrl('/static/profile_img_default.png', 140,140)" />
              </div>
              <div class="dsname">
                <h4>{{item.nickName}}</h4>
                <button
                  :key="1"
                  class="attenbtn following"
                  v-if="item.isFollow==1"
                  @click.stop.prevent="Follow(item)"
                  @mouseenter="toggleTitle1"
                  @mouseleave="toggleTitle2"
                >{{$t('global.已关注')}}</button>
                <button
                  :key="2"
                  class="attenbtn"
                  v-else
                  @click.stop.prevent="Follow(item)"
                >+ {{$t('global.关注')}}</button>
              </div>
              <p class="signatureuser" v-html="item.signature"></p>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="communActivity philosopher" v-if="questionList.length != 0">
        <strong>{{$t('global.热门文章')}}</strong>
        <span class="showAll" @click="navTo('activity')">
          {{$t('global.查看全部')}}
          <img src="/static/v2/match/view_all_tri.png" />
        </span>
      </div>
      <div class="deliberate" v-if="questionList.length != 0">
        <ul>
          <li v-for="mylist in questionList" :key="mylist.createTime">
            <p
              @click="toLinks(mylist)"
              class="titles"
              style="display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;line-clamp: 2;"
            >{{mylist.title}}</p>
            <div class="userinfor" :class="{'userType2':mylist.userType === 2 && mylist.isCertification === 1}">
              <img @click="myCenter(mylist)" :src="mylist.avatar | imageUrl('/static/profile_img_default.png',40,40)" />
              <span @click="myCenter(mylist)">{{mylist.nickName}}</span>
              <!-- <div class="userright">
                <img src="/static/home/images/eyes.png" />
                <span>{{mylist.collectionCount}}</span>
              </div>-->
            </div>
          </li>
        </ul>
      </div>

      <div class="communActivity philosopher" v-if="aboutCommunity.length > 0">
        <strong>{{$t('global.相关频道')}}</strong>
      </div>
      <div class="aboutCommunity" v-if="aboutCommunity.length > 0">
        <ul>
          <li v-for="item in aboutCommunity" :key="item.relevantTopicId">
            <router-link target="_blank" :to="'/subjectdetail/'+item.relevantTopicId">
              <img :src="item.relevantTopicThumb | imageUrl('', 132, 132)" />
              <div>
                <p>{{item.relevantTopicTitle}}</p>
                <div class="learning">
                  <span>{{$t('global.视频')}}</span>
                  <b>{{item.videoCount}}</b>
                  <span>{{$t('global.成员')}}</span>
                  <b>{{item.memberCount}}</b>
                </div>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import Event from "./Event.vue";
import ContentEmpty from "@/components/ContentEmpty";
import VideoCard from "@/components/v2/match/videoCard";
import Reload from "@/components/v2/match/reload";
import NoMore from "@/components/v2/NoMore";
import Loading from "@/components/v2/match/loading";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight
} from "@/assets/screen";

export default {
  components: {
    Event,
    ContentEmpty: ContentEmpty,
    VideoCard: VideoCard,
    Reload,
    NoMore,
    Loading
  },
  data() {
    return {
      activityStatusText: {
        "-1": "已删除",
        "1": this.$t('global.待审核'),
        "2": this.$t('live.即将开始'),
        "3": this.$t('global.审核未通过'),
        "4": this.$t('global.已结束'),
        "5": this.$t('global.进行中')
      },
      loadError: false,
      pageIndex: 1,
      videoLoading: true,
      hasNextPage: true,
      aboutCommunity: [],
      activitylist: [],
      philosopherman: [],
      questionList: [],
      topicId: null,
      designvideolist: [],
      sortVideoSelected: {
        id: "0",
        _id: 0,
        icon: "/static/v2/match/sort_default.png",
        title: this.$t("global.默认排序")
      },
      sortList: [
        {
          id: "0",
          _id: 0,
          icon: "/static/v2/match/sort_default.png",
          title: this.$t("global.默认排序")
        },
        {
          id: "1",
          _id: 1,
          icon: "/static/v2/match/sort_latest.png",
          title: this.$t("global.最新排序")
        },
        {
          id: "5",
          _id: 2,
          icon: "/static/v2/match/sort_hot.png",
          title: this.$t("global.热门排序")
        }
      ],
      showVideoSort: false
    };
  },
  created() {
    this.init();
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  methods: {
    init() {
      this.topicId = this.$route.params.id;
      this.getDesignVideoList();
      this.getQuestionList();
      this.getHostList();
      this.getPhilosopherMan();
      this.getAboutCommunity();
    },
    toLinks(item) {
      this.$router.push(
        `/discussDetail?id=${item.id}&author=${item.userId}&activeIndex=4&topicId=${this.topicId}`
      );
    },
    myCenter(item) {
      this.$router.push(`/peopleCenter/${item.userId}`);
    },
    Follow(item) {
      if (!localStorage.getItem("auth_token")) {
        this.$router.push("/login");
        return;
      }
      this.$http
        .post(
          `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
            item.userId
          }`
        )
        .then(res => {
          if (res.code === "OK") {
            item.isFollow = !item.isFollow;
            if (item.isFollow) {
              this.$message.success(res.message);
            } else {
              this.$message(res.message);
            }
          }
        });
    },
    toggleTitle1() {
      event.target.innerHTML = this.$t("global.取消关注");
      event.target.classList.add("focus");
    },
    toggleTitle2() {
      event.target.innerHTML = this.$t("global.已关注");
      event.target.classList.remove("focus");
    },
    navTo(target) {
      this.$router.push(target);
    },
    getAboutCommunity() {
      const params = {
        topicId: this.topicId,
        orderBy: 0,
        pageIndex: 1,
        pageSize: 4
      };
      this.$http.get("/api/topic/relevant/list", { params }).then(res => {
        if (res.code === "OK") {
          this.aboutCommunity = res.data.list;
        }
      });
    },
    getPhilosopherMan() {
      const params = {
        pageIndex: 1,
        pageSize: 8,
        topicId: this.topicId
      };
      this.$http
        .get("/api/2.0/topic/creaters", {
          params
        })
        .then(res => {
          if (res.code === "OK") {
            this.philosopherman = res.data.list;
          }
        });
    },
    getHostList() {
      const params = {
        topicId: this.topicId,
        pageIndex: 1,
        pageSize: 2
      };
      this.$http
        .get("/api/2.0/topic/activityLiveList", { params })
        .then(res => {
          if (res.code === "OK") {
            this.activitylist = res.data.data.list.filter(item => {
              return item.status == 2 || item.status == 5;
            });
            if (res.data.data.length > 2) {
              this.activitylist = res.data.data.list.slice(0, 2);
            }
          }
        });
    },
    getQuestionList() {
      const params = {
        topicId: this.topicId,
        pageIndex: 1,
        pageSize: 3
      };
      const url = "/api/2.0/topic/findArticleList";
      this.$http
        .get(url, {
          params
        })
        .then(res => {
          if (res.code === "OK") {
            this.questionList = res.data.list;
          }
        });
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 20) {
        if (!this.videoLoading && this.hasNextPage) {
          this.pageIndex++;
          this.getDesignVideoList();
        }
      }
    },
    getDesignVideoList() {
      this.videoLoading = true;
      const params = {
        topicId: this.topicId,
        status: 2,
        orderByType: this.sortVideoSelected.id,
        pageIndex: this.pageIndex,
        pageSize: 16
      };
      this.$http.get("/api/topic/videoList", { params }).then(res => {
        this.videoLoading = false;
        if (this.pageIndex === 1) {
          this.designvideolist = [];
        }
        if (res.code === "OK") {
          this.designvideolist = [...this.designvideolist, ...res.data.list];
          this.hasNextPage = res.data.hasNextPage;
          this.loadError = false;
        } else {
          this.pageIndex--;
          this.loadError = true;
        }
      });
    },
    showVideoSortList() {
      this.showVideoSort = true;
    },
    sortVideo() {
      this.sortVideoSelected = this.sortList[
        event.target.getAttribute("data-sort")
      ];
      this.pageIndex = 1;
      this.showVideoSort = false;
      this.getDesignVideoList();
    }
  }
};
</script>

<style lang="stylus" scoped>
.home {
  .content-left {
    float: left;
    width: 730px;
    margin-top: 40px;

    .video-box {
      display: flex;
      flex-direction: row;
      justify-content: space-between;

      strong {
        font-size: 24px;
        height: 33px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #0a0a0a;
      }

      div {
        line-height: 33px;
        text-align: center;
        position: relative;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;

        span {
          cursor: pointer;
          display: inline-block;
          color: #0A0A0A;
          font-size: 12px;
          cursor: pointer;
          line-height: 16px;

          img {
            width: 18px;
            height: 18px;
            vertical-align: sub;
            margin-top: 4px;
          }
        }

        ul {
          width: 125px;
          box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);
          border: 1px solid rgba(235, 235, 235, 1);
          position: absolute;
          top: 33px;
          left: -26px;
          z-index: 1;
          background: #fff;
          padding: 10px 0;

          li {
            line-height: 34px;
            cursor: pointer;

            &:hover {
              background: #F5F5F5;
            }

            img {
              width: 18px;
              height: 18px;
              vertical-align: sub;
            }
          }
        }
      }
    }

    .video-start {
      margin: 30px 0 40px;
      overflow: hidden;

      ul {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        li {
          float: left;
          width: 350px;
          margin: 0 30px 30px 0;
          overflow: hidden;
          position: relative;

          &:nth-child(2n) {
            margin-right: 0;
          }
        }
      }
    }
  }

  .advertising {
    position: relative;
    width: 320px;
    height: 107px;
    margin-bottom: 60px;
  }

  .advertising img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
    cursor: pointer;
  }

  .contentright {
    float: left;
    width: 285px;
    margin: 0 0 0 95px;
  }

  .contentright .directitem {
    position: relative;
    height: 45px;
    margin: 20px 0 60px 0;
  }

  .directitem li {
    float: left;
    width: 50px;
    height: 50px;
  }

  .directitem li img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 1px solid #e2e2e2;
  }

  .directitem ul {
    position: relative;
    width: auto;
    z-index: 10;
    height: 50px;
  }

  .directitem ul li {
    position: absolute;
    top: 0;
    left: 0;
  }

  .directitem ul li:nth-child(1) {
    z-index: 9;
  }

  .directitem ul li:nth-child(2) {
    z-index: 8;
    left: 30px;
  }

  .directitem ul li:nth-child(3) {
    z-index: 7;
    left: 60px;
  }

  .directitem ul li:nth-child(4) {
    z-index: 6;
    left: 90px;
  }

  .directitem ul li:nth-child(5) {
    z-index: 5;
    left: 120px;
  }

  .directitem ul li:nth-child(6) {
    z-index: 4;
    left: 150px;
  }

  .directitem ul li:nth-child(7) {
    z-index: 3;
    left: 180px;
  }

  .directitem ul li:nth-child(8) {
    z-index: 2;
    left: 210px;
  }

  .directitem ul li:nth-child(9) {
    z-index: 1;
    left: 240px;
  }

  .directitem ul li + .morelogos {
    width: 52px;
    height: 52px;
    margin-top: -3px;
  }

  .philosopher {
    margin: 40px 0 30px;
  }

  .philosoman {
    li {
      overflow: hidden;
      padding-bottom: 14px;
      margin-bottom: 14px;
      border-bottom: 1px solid rgba(237, 236, 241, 1);
      display: flex;
      align-items: center;

      a {
        width: 100%;
        position: relative;

        &.userType2::before {
          content: '';
          left: 55px;
          bottom: 5px;
          position: absolute;
          width: 16px;
          height: 16px;
          background: url('/static/v2/match/Verified_icon_blue_20.png');
          background-size: 16px;
        }
      }
    }
  }

  .philosoman li:last-child {
    margin-bottom: 56px;
  }
  .philosoman li .avatarLine{
    float: left;
    width: 71px;
    height: 71px;
    margin-right: 10px;
    border-radius: 50%;
    border: 1px solid #f5f5f5;
  }
  .philosoman li img {
    display: inline-block;
    width: 70px;
    height: 70px;
    margin-right: 10px;
    border-radius: 50%;
  }

  .philosoman li .dsname {
    color: #999;
    font-size: 12px;
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    h4 {
      font-size: 16px;
      color: #0A0A0A;
      font-weight: bold;
      margin-bottom: 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      flex: 1;
    }

    .attenbtn {
      width: 60px;
      height: 24px;
      border-radius: 2px;
      color: #2026CC;
      font-size: 12px;
      border: 1px solid #2026CC;
      background: #fff;

      &.attenbtn.following {
        border-color: #B8B8B8;
        color: #B8B8B8;

        &.focus {
          color: #999;
          border-color: #999;
        }
      }
    }
  }

  .signatureuser {
    height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    font-family: NunitoSans-Regular, NunitoSans;
    font-weight: 400;
    color: #999;
  }

  .aboutCommunity {
    ul {
      li {
        overflow: hidden;
        padding-bottom: 14px;
        margin-bottom: 14px;

        a {
          overflow: auto;
          display: flex;

          img {
            min-width: 66px;
            width: 66px;
            height: 66px;
            margin-right: 10px;
          }

          div {
            flex: 1;

            p {
              font-weight: bold;
              color: #333;
              font-size: 16px;
              // width: 220px;
              height: 44px;
              overflow: hidden;
              line-height: 22px;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }

            .learning {
              // width: 234px;
              font-size: 12px;
              color: #999;
              margin-top: 5px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400; 
              span {
                margin-right: 5px;
              }

              b {
                color: #999;
                margin-right: 8px;
                font-weight: 400; 
              }
            }
          }
        }

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }

  .communActivity {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    strong {
      font-size: 24px;
      color: rgba(51, 51, 51, 1);
    }

    span.showAll {
      display: inline-block;
      width: 60px;
      color: #0A0A0A;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      cursor: pointer;
      position: relative;
      margin-right: 12px;
      box-sizing: border-box;
      &:hover {
        border-bottom: 1px solid #0A0A0A;
      }

      img {
        position: absolute;
        margin-top: 6px;
        width: 7px;
        height: 9px;
        right: -8px;
      }
    }
  }

  .deliberate {
    padding-bottom: 15px;

    &.activitylist {
      ul {
        li {
          border-bottom: none;

          a {
            display: flex;
            flex-direction: row;
            align-items: center;

            .left {
              width: 95px;
              position: relative;
              margin-right: 10px;

              img {
                width: 95px;
                height: 126px;
              }

              .live {
                position: absolute;
                width: 40px;
                height: 20px;
                background: rgba(0, 0, 0, 0.8);
                border-radius: 2px;
                font-size: 12px;
                font-family: PingFangTC-Semibold, PingFangTC;
                font-weight: 600;
                color: rgba(255, 255, 255, 1);
                line-height: 20px;
                text-align: center;
                right: 5px;
                bottom: 5px;
              }

              span {
                position: absolute;
                top: 5px;
                right: -50px;
                width: 70px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                background: #2026CC;
                color: #fff;

                &.liveNow {
                  background: rgba(254, 86, 48, 1);
                  color: #fff;
                }

                &.ended {
                  background: #666;
                  color: #fff;
                }

                font-weight: 600; 
                &.start {
                  background: rgba(254, 86, 48, 1);
                }

                &.unstart {
                  background: rgba(32,38,204,1);
                }
              }
            }

            .right {
              flex: 1;
              margin-top: 20px;

              h4 {
                font-size: 15px;
                font-weight: 600;
                color: #0A0A0A;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                word-break: break-word;
              }

              span {
                font-size: 14px;
                color: #999;
                display: inline-block;
                padding-top: 10px;
              }
            }
          }
        }
      }
    }

    .titles {
      display: block;
      color: #333;
      font-size: 15px;
      font-weight: bold;
      max-height: 42px;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .userinfor {
      height: 26px;
      margin-top: 12px;
      color: #999;
      font-size: 12px;
      line-height: 20px;
      position: relative;

      &.userType2::before {
        content: '';
        left: 12px;
        top: 10px;
        position: absolute;
        width: 10px;
        height: 10px;
        background: url('/static/v2/match/Verified_icon_blue_20.png');
        background-size: 10px;
      }

      img {
        float: left;
        width: 20px;
        height: 20px;
        border-radius: 13px;
        cursor: pointer;

        &+span {
          float: left;
          display: inline-block;
          margin: 0 0 0 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          color: #333;
          &:hover{
            color: #0A0A0A;
          }
        }
      }

      .userright {
        float: right;
        display: flex;
        align-items: center;

        img {
          width: 14px;
          height: 10px;
        }

        span {
          font-size: 12px;
          color: #B8B8B8;
        }
      }
    }

    ul {
      li {
        position: relative;
        padding-bottom: 15px;
        border-bottom: 1px solid rgba(237, 236, 241, 1);

        &:first-child ~ li {
          margin-top: 15px;
        }
      }
    }
  }

  /* 发布弹窗 $t('global.登陆') */
  .fixpublish, .fixlogining {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.5);
  }

  .publishbtnbox, .loginingbox {
    position: fixed;
    width: 428px;
    height: 356px;
    top: 50%;
    left: 50%;
    z-index: 1001;
    transform: translate(-50%, -50%);
    background-color: #fff;
  }

  .changepublish {
    color: #333;
    font-size: 20px;
    width: 428px;
    text-align: center;
    margin-top: 30px;
  }

  .publishbtnbox .article {
    width: 358px;
    height: 63px;
    color: #999;
    font-size: 14px;
    line-height: 63px;
    border-radius: 5px;
    margin: 29px auto 0;
    cursor: pointer;
    border: 1px solid rgba(221, 221, 221, 1);
  }

  .publishbtnbox .article span {
    font-size: 24px;
    font-weight: bold;
    margin: 0 20px;
  }

  .publishbtnbox .question {
    width: 358px;
    height: 63px;
    color: #999;
    font-size: 14px;
    line-height: 63px;
    border-radius: 5px;
    margin: 20px auto 0;
    cursor: pointer;
    border: 1px solid rgba(221, 221, 221, 1);
  }

  .publishbtnbox .question span {
    font-size: 24px;
    font-weight: bold;
    margin: 0 20px;
  }

  .publishbtnbox div.active {
    color: #43c0bd;
    border: 1px solid rgba(67, 192, 189, 1);
  }

  .publishbtnbox a {
    display: inline-block;
    float: left;
    width: 100px;
    height: 40px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 44px;
    background-color: #4a90e2;
  }

  .publishbtnbox a.cancel {
    margin: 44px 20px 0 104px;
    background: rgba(202, 202, 202, 1);
  }

  .publishbtnbox img, .loginingbox img.closepopus {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }

  /* loginingbox  start */
  .loginingbox {
    height: 504px;
  }

  .loginingbox .headlogo {
    width: 130px;
    height: 34px;
    margin: 55px auto 0;
  }

  .loginingbox .headlogo img {
    width: 100%;
    height: 100%;
  }

  .loginingbox .loginform {
    padding: 50px 64px 0;
  }

  .loginingbox .loginform input.userinfor {
    width: 100%;
    height: 40px;
    font-size: 16px;
    margin-bottom: 30px;
    border-bottom: 1px solid #e8e8e8;
  }

  .loginingbox .loginbtn {
    display: block;
    width: 100%;
    height: 40px;
    text-align: center;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    line-height: 40px;
    background-color: #abaaba;
  }

  .loginingbox .goregister {
    display: block;
    color: #999;
    font-size: 12px;
    text-align: center;
    cursor: pointer;
    margin-top: 22px;
  }

  .loginingbox .otherlogin {
    text-align: center;
    color: #999;
    font-size: 12px;
    margin-top: 30px;
  }

  .loginingbox .otherlogin span {
    display: inline-block;
    position: relative;
    width: 100px;
  }

  .loginingbox .otherlogin span:after {
    position: absolute;
    display: block;
    content: '';
    height: 1px;
    width: 120px;
    top: 8px;
    left: 130px;
    background-color: #e8e8e8;
  }

  .loginingbox .otherlogin span:before {
    position: absolute;
    display: block;
    content: '';
    height: 1px;
    width: 120px;
    top: 8px;
    right: 130px;
    background-color: #e8e8e8;
  }

  /* login-way */
  .login-ways {
    text-align: center;
    margin-top: 30px;
  }

  .login-ways span {
    cursor: pointer;
  }

  .login-way {
    display: inline-block;
    width: 0.36rem;
    height: 0.36rem;
    margin: 0 0.275rem;
  }

  .lefttypes {
    position: absolute;
    color: #fff;
    top: 2px;
    left: 0;
    font-size: 12px;
    padding: 1px 7px;
    border-radius: 3px;
    background-color: #df7979;
  }

  .colortype {
    background-color: #4a90e2;
  }

  .login-way-qq {
    background: url('/static/qq.png') no-repeat center center;
    background-size: contain;
  }

  .login-way-wechat {
    background: url('/static/wechat.png') no-repeat center center;
    background-size: contain;
  }

  .login-way-weibo {
    background: url('/static/weibo.png') no-repeat center center;
    background-size: contain;
  }

  .loginform input::-webkit-input-placeholder {
    color: #999;
    font-size: 16px;
  }

  .loginform input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #999;
    font-size: 16px;
  }

  .loginform input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #999;
    font-size: 16px;
  }

  .loginform input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #999;
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/subject/channel/Home.vue